import Endpoints from 'constants/Endpoints';
import {RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import HeaderService from 'services/HeaderService';
import reduxStore from 'redux/store';
import {clearResource, setResource} from 'redux/actions';

const updateHeader = (resp, demandId) => {
    if (resp.success) {
        HeaderService.get(demandId);
        return true;
    } else {
        return false;
    }
}

export const modify = async (demandId) => {
    try {
        const resp = await RestRequestPOST(Endpoints.DEMAND_MODIFICATION(demandId));
        return updateHeader(resp, demandId);
    } catch (error) {
    }
    return false;
};

export const publish = async (demandId) => {
    try {
        const resp = await RestRequestPOST(Endpoints.DEMAND_MODIFICATION_PUBLISH(demandId));
        return updateHeader(resp, demandId);
    } catch (error) {
    }
};

export const cancel = async (demandId) => {
    try {
        const resp = await RestRequestPOST(Endpoints.DEMAND_MODIFICATION_CANCEL(demandId));
        return updateHeader(resp, demandId);
    } catch (error) {
    }
};

const backToModification = async (id) => {
    const res = await RestRequestPOST(Endpoints.DEMAND_BACK_TO_MODIFICATION(id));
    if (res.success) {
        return res.result;
    }
}

export const publishOjsNotice = async (demandId) => {
    try {
        const res = await RestRequestPOST(Endpoints.DEMAND_MODIFICATION_PUBLISH_OJS(demandId));
        return res;
    } catch (error) {
    }
};

export const rollbackOjsNotice = async (demandId) => {
    try {
        const res = await RestRequestPOST(Endpoints.DEMAND_MODIFICATION_ROLLBACK_OJS(demandId))
        return res
    } catch (error) {
    }
};

export const noticeOjsStatus = async (demandId) => {
    try {
        const res = await RestRequestGET(Endpoints.DEMAND_MODIFICATION_OJS_STATUS(demandId));
        reduxStore.dispatch(
            setResource('ojsPublicationStatus', res)
        );
        return res;
    } catch (error) {
    }
};

export const clearDemandChanged = () => {
    reduxStore.dispatch(clearResource('isDemandChanged'));
}
export const isDemandChanged = async (demandId) => {
    try {
        const res = await RestRequestGET(Endpoints.DEMAND_MODIFICATION_CHANGED(demandId));
        reduxStore.dispatch(
            setResource('isDemandChanged', res)
        );
    } catch (error) {
    }
};

export default {
    modify,
    publish,
    cancel,
    backToModification,
    publishOjsNotice,
    rollbackOjsNotice,
    noticeOjsStatus,
    isDemandChanged,
    clearDemandChanged,
}